jQuery(function($) {

    /**
     * My Account Delete Class.
     *
     * Handles the delete account confirmation process with AJAX.
     */
    class My_Account {

        /**
         * Constructor.
         * Initializes event handlers.
         */
        constructor() {
            this.init();
        }

        /**
         * Initialize event handlers.
         */
        init() {
            this.eventHandlers();
        }

        /**
         * Bind event handlers.
         */
        eventHandlers() {
            // Click handler for delete account confirmation button.
            $(document.body).on('click', '.delete-account-confirmation-btn', this.confirmDelete.bind(this));
        }

        /**
         * Perform AJAX request to delete account.
         *
         * @param {Event} e Event object.
         */
        confirmDelete(e) {
            e.preventDefault();

            let $btn = $(e.currentTarget);

            $.ajax({
                url: mpParams.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'delete_my_account', // PHP action hook.
                    security: mpParams.nonce
                },
                beforeSend: () => {
                    $btn.addClass('loading').prop('disabled', true);
                },
                success: (response) => {
                    if (response.success) {
                        $htn.parent(".pandora-model-body").html('<p>' + response.data.message + '</p>');
                        if (response.data.redirect) {
                            window.location.href = response.data.redirect;
                        }
                    } else {
                        window.location.reload();
                    }
                },
                error: () => {
                    alert('An error occurred. Please try again.');
                },
                complete: () => {
                    $btn.removeClass('loading').prop('disabled', false);
                }
            });
        }
    }

    // Initialize delete account script.
    new My_Account();

});
